export default {
  computed: {
    /**
     * checks if the user's subscription plan is restricted
     */
    isPlanRestricted() {
      const { subscription } = this.$store.state;

      // handle cases where subscription or plan is missing
      if (!subscription || !subscription.plan) {
        console.warn("subscription data is missing or undefined");
        return true; // treat as restricted if data is missing
      }
      const restrictedPlans = new Set([
        "free",
        "basic",
        "annual-basic",
        "standard",
        "annual-standard",
        undefined, // include undefined as restricted
      ]);

      return restrictedPlans.has(
        subscription.plan.group?.trim()?.toLowerCase()
      );
    },

    /**
     * checks if the Pro Advanced option is restricted, considering GPU upgrade warning
     */
    isProAdvancedOptionRestricted() {
      const { showGpuUpgradeWarning } = this.$store.state;

      return showGpuUpgradeWarning && this.isPlanRestricted;
    },
  },
};
